/** Формы слова «курорт» для pluralize: [один, 2–4, 5 и больше]. */
export const RESORT_PLURAL_FORMS = ['курорт', 'курорта', 'курортов'];
